<!-- Start Banner Area
============================================= -->
<div class="banner-area banner-style-one shadow zoom-effect overflow-hidden text-light">
  <!-- Slider main container -->
  <div class="banner-fade">
    <!-- Additional required wrapper -->
    <div class="swiper-wrapper">

      <!-- Single Item -->
      <div class="swiper-slide banner-style-one">
        <div class="banner-thumb bg-cover shadow theme" style="background: url(assets/img/banner/Sliders3.png); "></div>
        <div class="container">
          <div class="row align-center">
            <div class="col-xl-8 offset-xl-4">
              <div class="content">
                <h4>Enterprise Cloud ERP</h4>
                <h2>Architecting Scalable Platforms for Mission-Critical Operations</h2>
                <div class="button mt-40">
                  <a class="btn btn-theme btn-md radius animation" routerLink="/about-us">Discover More</a>
                  <a class="btn btn-border-light btn-md radius animation ms-3" routerLink="/contact">Book A Demo</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Shape -->
        <div class="banner-shape-bg">
          <img src="assets/img/shape/1.png" alt="Shape">
        </div>
        <!-- End Shape -->
      </div>
      <!-- End Single Item -->
      <!-- Single Item -->
      <div class="swiper-slide banner-style-one">
        <div class="banner-thumb bg-cover shadow theme" style="background: url(assets/img/banner/Sliders4.png); "></div>
        <div class="container">
          <div class="row align-center">
            <div class="col-xl-8 offset-xl-4">
              <div class="content">
                <h4>Higher Education Automation</h4>
                <h2>Digital Ecosystems for University Evaluation & Campus Life</h2>
                <div class="button mt-40">
                  <a class="btn btn-theme btn-md radius animation" routerLink="/portfolio">View Case Studies</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Shape -->
        <div class="banner-shape-bg">
          <img src="assets/img/shape/1.png" alt="Shape">
        </div>
        <!-- End Shape -->
      </div>
      <!-- End Single Item -->
      <!-- Single Item -->
      <div class="swiper-slide banner-style-one">
        <div class="banner-thumb bg-cover shadow theme" style="background: url(assets/img/banner/Sliders1.png); "></div>
        <div class="container">
          <div class="row align-center">
            <div class="col-xl-8 offset-xl-4">
              <div class="content">
                <h4>Intelligent Telematics & Fleet</h4>
                <h2>Integrated Fleet Dispatch, Telematics & Fuel Tracking</h2>
                <div class="button mt-40">
                  <a class="btn btn-theme btn-md radius animation" href="https://norbix.novarix.tech/products/novafleet" target="_blank">Explore NovaFLEET</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Shape -->
        <div class="banner-shape-bg">
          <img src="assets/img/shape/1.png" alt="Shape">
        </div>
        <!-- End Shape -->
      </div>
      <!-- End Single Item -->
      <!-- Single Item -->
      <div class="swiper-slide banner-style-one">
        <div class="banner-thumb bg-cover shadow theme" style="background: url(assets/img/banner/Sliders2.png); "></div>
        <div class="container">
          <div class="row align-center">
            <div class="col-xl-8 offset-xl-4">
              <div class="content">
                <h4>IoT & Biometric Hardware</h4>
                <h2>Secure Edge Gateways & Real-Time Biometric Systems</h2>
                <div class="button mt-40">
                  <a class="btn btn-theme btn-md radius animation" routerLink="/services">Our Solutions</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Shape -->
        <div class="banner-shape-bg">
          <img src="assets/img/shape/1.png" alt="Shape">
        </div>
        <!-- End Shape -->
      </div>
      <!-- End Single Item -->
      <!-- Single Item -->
      <div class="swiper-slide banner-style-one">
        <div class="banner-thumb bg-cover shadow theme" style="background: url(assets/img/banner/Sliders5.png); "></div>
        <div class="container">
          <div class="row align-center">
            <div class="col-xl-8 offset-xl-4">
              <div class="content">
                <h4>Workforce & Payroll Suite</h4>
                <h2>End-to-End Employee Lifecycle & GPS Punch with NovaHRM</h2>
                <div class="button mt-40">
                  <a class="btn btn-theme btn-md radius animation" href="https://norbix.novarix.tech/products/novahrm" target="_blank">Explore NovaHRM</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Shape -->
        <div class="banner-shape-bg">
          <img src="assets/img/shape/1.png" alt="Shape">
        </div>
        <!-- End Shape -->
      </div>
      <!-- End Single Item -->
    </div>

    <!-- Navigation -->
    <div class="swiper-button-prev">
      <i class="fas fa-angle-left"></i>
    </div>
    <div class="swiper-button-next">
      <i class="fas fa-angle-right"></i>
    </div>

  </div>
</div>
<!-- End Main -->

<!-- Start Trusted By Area
============================================= -->
<div class="trusted-by-area pt-30 pb-30 bg-light border-bottom">
  <div class="container">
    <div class="row align-center">
      <div class="col-lg-3 col-md-12 text-md-center mb-md-20">
        <span class="text-uppercase text-muted fw-bold" style="letter-spacing: 1.2px; font-size: 13px;">
          Trusted by Premier Institutions & Universities
        </span>
      </div>
      <div class="col-lg-9 col-md-12">
        <div class="row justify-content-around align-center text-center gy-3">
          <div class="col-12 col-md-4">
            <div class="client-badge p-3 bg-white rounded shadow-sm border text-start">
              <div class="d-flex align-items-center">
                <i class="fas fa-university text-primary fa-2x me-3" style="margin-right: 12px; color: #2563eb;"></i>
                <div>
                  <h6 class="mb-0 fw-bold" style="font-size: 14px;">JNTUA Anantapur</h6>
                  <small class="text-muted" style="font-size: 11px;">State University Partner</small>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="client-badge p-3 bg-white rounded shadow-sm border text-start">
              <div class="d-flex align-items-center">
                <i class="fas fa-graduation-cap text-success fa-2x me-3" style="margin-right: 12px; color: #16a34a;"></i>
                <div>
                  <h6 class="mb-0 fw-bold" style="font-size: 14px;">SBES, Anantapur</h6>
                  <small class="text-muted" style="font-size: 11px;">Sri Balaji Educational Society</small>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="client-badge p-3 bg-white rounded shadow-sm border text-start">
              <div class="d-flex align-items-center">
                <i class="fas fa-laptop-code text-info fa-2x me-3" style="margin-right: 12px; color: #0284c7;"></i>
                <div>
                  <h6 class="mb-0 fw-bold" style="font-size: 14px;">PVKKIT Campus</h6>
                  <small class="text-muted" style="font-size: 11px;">Enterprise ERP & Assessment</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- End Trusted By Area -->

<!-- Start About
============================================= -->
<div class="about-style-five-area default-padding">
  <div class="container">
    <div class="row align-center">
      <div class="col-lg-6 pr-70 pr-md-15 pr-xs-15">
        <div class="about-style-five-left-info">
          <div class="fun-fact">
            <div class="counter">
              <div class="timer" data-to="846" data-speed="2000">17</div>
              <div class="operator">+</div>
            </div>
            <h4>Years of Engineering Experience <a href="#"><i class="fas fa-long-arrow-right"></i></a></h4>
          </div>
          <img src="assets/img/about/3.png" alt="Image Not Found">
        </div>
      </div>
      <div class="col-lg-6">
        <div class="about-style-five-right-info">
          <h4 class="sub-title">About NOVARIX</h4>
          <h4>Delivering Secure, Scalable & Intelligent Technology Solutions</h4>
          <p>
            At Novarix Tech, we specialize in building modern digital systems that combine secure cloud architecture,
            IoT integration, and enterprise-grade application development.
          </p>
          <p>
            From distributed systems and encrypted data platforms to full-stack web solutions, we help organizations
            transform complex requirements into reliable, scalable, and future-ready technology.
          </p>
          <div class="list-card">
            <h4>Our Engineering Approach</h4>
            <p>
              We focus on designing systems that are secure by default, scalable by design, and optimized for real-world
              performance. Our team combines deep technical expertise with practical execution to deliver solutions that
              stand the test of time.
            </p>
            <ul class="list-style-two">
              <li>Secure cloud-native architectures with advanced authentication</li>
              <li>IoT-enabled platforms with real-time device integration</li>
              <li>Enterprise-grade applications built on modern tech stacks</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- End About -->
<!-- Start Services
============================================= -->
<div class="services-style-six-area default-padding bottom-less bg-gray"
  style="background-image: url(assets/img/shape/54.png);">
  <div class="container">
    <div class="row">
      <div class="col-lg-8 offset-lg-2">
        <div class="site-heading text-center">
          <h4 class="sub-title">What we do</h4>
          <h2 class="title split-text">Our Products</h2>
          <div class="devider"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="container carousel-container">
    <div class="services-style-six-items services-carousel swiper">
      <div class="swiper-wrapper">
        <!-- Single Item: Norbix Enterprise -->
        <div class="swiper-slide services-style-six-item hover-active-item">
          <div class="item">
            <div class="icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                   stroke-linecap="round" stroke-linejoin="round" style="stroke-width:var(--ng-icon__stroke-width, 2)">
                <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
                <line x1="8" y1="21" x2="16" y2="21"></line>
                <line x1="12" y1="17" x2="12" y2="21"></line>
              </svg>
            </div>
            <h4><a href="https://norbix.novarix.tech" target="_blank">Norbix Enterprise</a></h4>
            <h6>Unified Multi-Tenant Cloud ERP Suite</h6>
            <p>
              An all-in-one cloud operations command platform uniting workforce management, fleet dispatch, financial accounting, and communications into a single enterprise database with native Android mobile companion apps.
            </p>
            <h5>Key capabilities</h5>
            <ul>
              <li>Multi-tenant cloud architecture & isolated data</li>
              <li>Modular suites: NovaHRM, NovaFLEET, NovaFinance, NovaCONNECTS</li>
              <li>3 Android companion mobile apps (NovaHRM, NovaDRIVE, NovaCONNECTS)</li>
              <li>Automated daily Hangfire compliance & birthday alerts</li>
              <li>Cross-module double-entry ledger & GST invoicing</li>
              <li>Real-time SignalR in-app & FCM push notifications</li>
              <li>Role-based access control & tenant white-labeling</li>
            </ul>
          </div>
        </div>
        <!-- End Single Item: Norbix Enterprise -->
        <!-- Single Item -->
        <div class="swiper-slide services-style-six-item hover-active-item">
          <div class="item">
            <div class="icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                   stroke-linecap="round" stroke-linejoin="round" style="stroke-width:var(--ng-icon__stroke-width, 2)">
                <path d="M18 21a8 8 0 0 0-16 0"></path>
                <circle cx="10" cy="8" r="5"></circle>
                <path d="M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3"></path>
              </svg>
            </div>
            <h4><a href="https://norbix.novarix.tech/products/novahrm">NovaHRM</a></h4>
            <h6>Workforce management, reimagined</h6>
            <p>
              A dedicated human resource management platform for organizations that need employee lifecycle control,
              attendance intelligence, geofenced mobile punch, leave and payroll workflows, and compliance-ready
              documentation — all in one connected system.
            </p>
            <h5>Key capabilities</h5>
            <ul>
              <li>Employee onboarding & profiles</li>
              <li>Attendance & correction tracking</li>
              <li>GPS mobile punch & photo proof</li>
              <li>Live location & route tracking</li>
              <li>Leave & balance management</li>
              <li>Payroll & payslip generation</li>
              <li>Document & compliance tracking</li>
              <li>HRM & payroll reporting</li>
              <li>Role-based access control</li>
            </ul>
          </div>
        </div>
        <!-- End Single Item -->
        <!-- Single Item -->
        <div class="swiper-slide services-style-six-item hover-active-item active">
          <div class="item">
            <div class="icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" style="stroke-width:var(--ng-icon__stroke-width, 2)"><path d="M10 10H6"></path><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"></path><path d="M19 18h2a1 1 0 0 0 1-1v-3.28a1 1 0 0 0-.684-.948l-1.923-.641a1 1 0 0 1-.578-.502l-1.539-3.076A1 1 0 0 0 16.382 8H14"></path><path d="M8 8v4"></path><path d="M9 18h6"></path><circle cx="17" cy="18" r="2"></circle><circle cx="7" cy="18" r="2"></circle></svg>
            </div>
            <h4><a href="https://norbix.novarix.tech/products/novafleet">NovaFLEET</a></h4>
            <h6>Complete transport enterprise suite</h6>
            <p>
              An integrated operations platform combining workforce management, fleet operations, and financial accounting into one unified command layer. Built for transport-led organizations managing drivers, vehicles, trips, HR, and finances together.
            </p>
            <h5>Key capabilities</h5>
            <ul>
              <li>NovaHRM: HR & payroll management</li>
              <li>NovaFleet: Fleet & asset tracking</li>
              <li>NovaFinance: Ledger & invoicing</li>
              <li>Real-time GPS & geo-fencing</li>
              <li>Instant maintenance & payroll alerts</li>
              <li>Full operations-to-finance audit</li>
              <li>Multi-role reporting dashboard</li>
              <li>Mobile app for drivers & updates</li>
            </ul>
          </div>
        </div>
        <!-- End Single Item -->
        <!-- Single Item -->
        <div class="swiper-slide services-style-six-item hover-active-item">
          <div class="item">
            <div class="icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" style="stroke-width:var(--ng-icon__stroke-width, 2)"><path d="m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5"></path><rect x="2" y="6" width="14" height="12" rx="2"></rect></svg>
            </div>
            <h4><a href="https://norbix.novarix.tech/products/novaconnects">NovaConnects</a></h4>
            <h6>Voice/video call & prepaid billing engine</h6>
            <p>
              A communications and prepaid billing engine facilitating secure voice and video calls between parents and students. Enforces strict calling schedules, manages prepaid balances, and automates ledger transactions.
            </p>
            <h5>Key capabilities</h5>
            <ul>
              <li>Parent & student registration</li>
              <li>Wallet & payment tracking</li>
              <li>Scheduled weekly calling</li>
              <li>Voice & video call rates</li>
              <li>Live audio/video calling</li>
              <li>Automatic wallet deductions</li>
              <li>Admin & college dashboard</li>
              <li>Call & payment reports</li>
              <li>Session & recharge logs</li>
            </ul>
          </div>
        </div>
        <!-- End Single Item -->

        <!-- Single Item -->
        <div class="swiper-slide services-style-six-item hover-active-item">
          <div class="item">
            <div class="icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" style="stroke-width:var(--ng-icon__stroke-width, 2)"><path d="M22 10v6M2 10l10-5 10 5-10 5z"></path><path d="M6 12v5c0 2 2 3 6 3s6-1 6-3v-5"></path></svg>
            </div>
            <h4><a href="https://compass.novarix.tech/">Norbix Compass</a></h4>
            <h6>The complete Academic ERP Suite for Colleges & Universities</h6>
            <p>
              A comprehensive, secure multi-tenant platform purpose-built to unify all operations under one single database: student admissions & lifecycle, staff onboarding & allotments, biometric attendance, centralized payroll, digital library systems, transport routing, hostel allocation, and central fee fixation.
            </p>
            <h5>Key capabilities</h5>
            <ul>
              <li>Multi-college administration</li>
              <li>Employee onboarding & records</li>
              <li>Salary, PF, ESI & tax setups</li>
              <li>Staff posting & transfers</li>
              <li>Student admission & lifecycle</li>
              <li>Fee & scholarship tracking</li>
              <li>Library books & circulation</li>
              <li>Bus routes & fleet details</li>
              <li>Hostels & room allocation</li>
            </ul>
          </div>
        </div>
        <!-- End Single Item -->
      </div>
    </div>
    <!-- Navigation Buttons on the sides -->
    <div class="services-button-prev slider-nav-btn prev-btn"><i class="fas fa-angle-left"></i></div>
    <div class="services-button-next slider-nav-btn next-btn"><i class="fas fa-angle-right"></i></div>
  </div>
</div>
<!-- End Services -->
<!-- Start Services
============================================= -->
<div class="services-style-six-area default-padding bottom-less bg-gray"
  style="background-image: url(assets/img/shape/54.png);">
  <div class="container">
    <div class="row">
      <div class="col-lg-8 offset-lg-2">
        <div class="site-heading text-center">
          <h4 class="sub-title">What we do</h4>
          <h2 class="title split-text">Technical Solutions Engineered <br> for Enterprise Scale</h2>
          <div class="devider"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="services-style-six-items">
      <div class="row">
        <!-- Single Item -->
        <div class="col-lg-4 col-md-6 mb-30 services-style-six-item hover-active-item">
          <div class="item">
            <div class="icon">
              <img src="assets/img/icon/44.png" alt="Image Not Found">
            </div>
            <h4><a routerLink="/services">Enterprise Software Development & System Engineering</a></h4>
            <p>
              We design and build enterprise-grade applications with a strong focus on scalability, performance, and
              long-term maintainability. Our expertise includes distributed system design, API-driven architectures, and
              modern full-stack development tailored for complex business environments.
            </p>
            <ul>
              <li>Distributed Systems</li>
              <li>Cloud Applications</li>
              <li>System Modernization</li>
            </ul>
          </div>
        </div>
        <!-- End Single Item -->
        <!-- Single Item -->
        <div class="col-lg-4 col-md-6 mb-30 services-style-six-item hover-active-item active">
          <div class="item">
            <div class="icon">
              <img src="assets/img/icon/45.png" alt="Image Not Found">
            </div>
            <h4><a routerLink="/services">AI-Powered Solutions & Intelligent Automation</a></h4>
            <p>
              We build intelligent systems that leverage AI and automation to enhance decision-making and operational
              efficiency. From AI-enabled applications to data-driven workflows, we integrate modern AI capabilities
              into scalable cloud platforms.
            </p>
            <ul>
              <li>AI-Enabled Applications</li>
              <li>Intelligent Automation</li>
              <li>Data-Driven Systems</li>
            </ul>
          </div>
        </div>
        <!-- End Single Item -->
        <!-- Single Item -->
        <div class="col-lg-4 col-md-6 mb-30 services-style-six-item hover-active-item">
          <div class="item">
            <div class="icon">
              <img src="assets/img/icon/46.png" alt="Image Not Found">
            </div>
            <h4><a routerLink="/services">Cloud, IoT & Intelligent Platform Solutions</a></h4>
            <p>
              We develop integrated solutions that connect devices, applications, and cloud platforms. From biometric
              systems to smart monitoring solutions, we enable secure IoT ecosystems with real-time data processing and
              scalable cloud infrastructure.
            </p>
            <ul>
              <li>IoT & Device Integration</li>
              <li>Smart Systems</li>
              <li>Cloud</li>
              <li>Real-Time Data Systems</li>
            </ul>
          </div>
        </div>
        <!-- End Single Item -->
      </div>
    </div>
  </div>
</div>
<!-- End Services -->
<!-- Start Why Choose Us
============================================= -->
<div class="choose-us-style-four-area default-padding bg-dark text-light">
  <div class="container">
    <div class="row">
      <div class="col-lg-6 pr-80 pr-md-15 pr-xs-15">
        <div class="choose-us-four-thumb">
          <img src="assets/img/about/12.jpg" alt="Image Not Found">
          <img src="assets/img/about/13.jpg" alt="Image Not Found">
          <img src="assets/img/shape/50.png" alt="Image Not Found">
          <div class="button text-end">
            <a class="btn btn-theme btn-md radius animation" routerLink="/about-us">Discover More</a>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="choose-us-four-info">
          <h4 class="sub-title">NEXT-GEN technology solutions</h4>
          <h2 class="title">Elevate Your Business with Secure, Intelligent & Scalable Systems</h2>
          <p>
            At Novarix Tech, we combine deep engineering expertise with modern technologies to build secure,
            high-performance digital platforms. From distributed cloud systems to AI-powered applications and IoT
            integrations, we help businesses innovate, scale, and stay future-ready.
          </p>
          <ul class="list-card-two">
            <li>
              <h5>AI-Powered Solutions & Intelligent Automation</h5>
              <p>
                We design and integrate AI-driven systems that enhance decision-making, automate workflows, and unlock
                new efficiencies across your business operations.
              </p>
            </li>
            <li>
              <h5>Enterprise Software & Cloud Engineering</h5>
              <p>
                We build scalable, cloud-native applications using modern architectures, ensuring high availability,
                performance, and long-term maintainability across enterprise environments.
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- End Choose Us -->
<!-- Start Expertise
============================================= -->
<div class="expterise-style-one-area default-padding">
  <div class="container">
    <div class="row">
      <div class="col-lg-6">
        <div class="expertise-style-one-info">
          <h4 class="sub-title">Expert in technology solution</h4>
          <h2 class="title">Building Reliable, Secure & Future-Ready Digital Systems</h2>
          <p>
            At Novarix Tech, we combine deep engineering expertise with modern technologies to deliver solutions that
            drive real business impact. From secure cloud architectures and distributed systems to AI-powered
            applications and IoT integrations, we design platforms that are scalable, resilient, and built for long-term
            success.
          </p>
          <p>
            Our approach focuses on performance, security, and adaptability — ensuring your systems evolve with your
            business.
          </p>
          <div class="ceo-quote">
            <div class="left">
              <h4>Novarix Tech</h4>
              <span>Engineering Excellence • Secure by Design • Built to Scale</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 pl-60 pl-md-15 pl-xs-15">
        <div class="expertise-style-one-thumb">
          <img src="assets/img/about/11.jpg" alt="Image Not Found">
          <div class="skill-items">
            <!-- Progress Bar Start -->
            <div class="progress-box">
              <h5>90% - Cloud & Distributed Systems</h5>
              <div class="progress">
                <div class="progress-bar" role="progressbar" data-width="80"></div>
              </div>
            </div>
            <div class="progress-box">
              <h5>85% - AI & Intelligent Automation</h5>
              <div class="progress">
                <div class="progress-bar" role="progressbar" data-width="90"></div>
              </div>
            </div>
            <!-- End Progressbar -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- End Expertise-->
<!-- Start Technology Index
============================================= -->
<div class="technolgy-index-two-area default-padding bg-dark text-light bg-cover"
  style="background-image: url(assets/img/shape/banner-9.jpg);">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div class="left-heading-two">
          <div class="left-info">
            <h4 class="sub-title">Technology Index</h4>
            <h2 class="title">Battle-tested modern stacks powering our enterprise platforms</h2>
          </div>
          <div class="right-info">
            <div class="fun-fact">
              <div class="counter">
                <div class="timer" data-to="100" data-speed="2000">100</div>
                <div class="operator">K+</div>
              </div>
              <span class="medium">Student & Institutional Records</span>
            </div>
            <div class="fun-fact">
              <div class="counter">
                <div class="timer" data-to="99" data-speed="2000">99.9</div>
                <div class="operator">%</div>
              </div>
              <span class="medium">High-Availability Uptime SLA</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div class="technology-index-two-items text-center">
          <!-- Single Item -->
          <div class="tech-index-two-item">
            <a href="#">
              <div class="icon">
                <img src="assets/img/icon/mailchimp.png" alt="Imaeg Not Found">
                <img src="assets/img/icon/mailchimp-light.png" alt="Imaeg Not Found">
              </div>
              <h5>MAILCHIMP</h5>
            </a>
          </div>
          <!-- End Single Item -->
          <!-- Single Item -->
          <div class="tech-index-two-item">
            <a href="#">
              <div class="icon">
                <img src="assets/img/icon/php.png" alt="Imaeg Not Found">
                <img src="assets/img/icon/php-light.png" alt="Imaeg Not Found">
              </div>
              <h5>PHP</h5>
            </a>
          </div>
          <!-- End Single Item -->
          <!-- Single Item -->
          <div class="tech-index-two-item">
            <a href="#">
              <div class="icon">
                <img src="assets/img/icon/postgesql.png" alt="Imaeg Not Found">
                <img src="assets/img/icon/postgesql-light.png" alt="Imaeg Not Found">
              </div>
              <h5>POSTGRESQL</h5>
            </a>
          </div>
          <!-- End Single Item -->
          <!-- Single Item -->
          <div class="tech-index-two-item">
            <a href="#">
              <div class="icon">
                <img src="assets/img/icon/java.png" alt="Imaeg Not Found">
                <img src="assets/img/icon/java-light.png" alt="Imaeg Not Found">
              </div>
              <h5>JAVASCRIPT</h5>
            </a>
          </div>
          <!-- End Single Item -->
          <!-- Single Item -->
          <div class="tech-index-two-item">
            <a href="#">
              <div class="icon">
                <img src="assets/img/icon/swift.png" alt="Imaeg Not Found">
                <img src="assets/img/icon/swift-light.png" alt="Imaeg Not Found">
              </div>
              <h5>SWIFT</h5>
            </a>
          </div>
          <!-- End Single Item -->
          <!-- Single Item -->
          <div class="tech-index-two-item">
            <a href="#">
              <div class="icon">
                <img src="assets/img/icon/paython.png" alt="Imaeg Not Found">
                <img src="assets/img/icon/paython-light.png" alt="Imaeg Not Found">
              </div>
              <h5>PYTHON</h5>
            </a>
          </div>
          <!-- End Single Item -->
        </div>
      </div>
    </div>
  </div>
</div>
<!-- End Technology Index -->
<!-- Start Team
============================================= -->
<div class="team-style-four-area default-padding bg-cover" style="background-image: url(assets/img/shape/55.png);">
  <div class="container">
    <div class="row">
      <div class="col-lg-8 offset-lg-2">
        <div class="site-heading text-center">
          <h4 class="sub-title">Engineering Leadership</h4>
          <h2 class="title split-text">Multidisciplinary Teams <br> Behind Our Platforms</h2>
          <div class="devider"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="team-style-two-items">
      <div class="row">
        <!-- Single Item -->
        <div class="col-xl-3 col-lg-6 col-md-6 team-style-four-item">
          <div class="item">
            <div class="thumb">
              <img src="assets/img/team/5.jpg" alt="Cloud Architecture Team">
              <span>Cloud & Infra</span>
            </div>
            <h4><a routerLink="/organizational-chart">Cloud Architecture & Security</a></h4>
            <div class="social-overlay">
              <p class="text-white px-3 text-center small mb-0">High-concurrency microservices, Azure Entra ID & distributed DBs</p>
              <div class="icon">
                <a routerLink="/organizational-chart"><i class="fas fa-arrow-right"></i></a>
              </div>
            </div>
          </div>
        </div>
        <!-- End Single Item -->
        <!-- Single Item -->
        <div class="col-xl-3 col-lg-6 col-md-6 team-style-four-item">
          <div class="item">
            <div class="thumb">
              <img src="assets/img/team/6.jpg" alt="Enterprise Software Team">
              <span>Core ERP</span>
            </div>
            <h4><a routerLink="/organizational-chart">Enterprise Product Engineering</a></h4>
            <div class="social-overlay">
              <p class="text-white px-3 text-center small mb-0">Norbix Suite, NovaHRM, NovaFLEET & mobile companion apps</p>
              <div class="icon">
                <a routerLink="/organizational-chart"><i class="fas fa-arrow-right"></i></a>
              </div>
            </div>
          </div>
        </div>
        <!-- End Single Item -->
        <!-- Single Item -->
        <div class="col-xl-3 col-lg-6 col-md-6 team-style-four-item">
          <div class="item">
            <div class="thumb">
              <img src="assets/img/team/7.jpg" alt="IoT & Hardware Team">
              <span>IoT & Edge</span>
            </div>
            <h4><a routerLink="/organizational-chart">IoT & Telematics Engineering</a></h4>
            <div class="social-overlay">
              <p class="text-white px-3 text-center small mb-0">Biometric turnstiles, CAN-bus telematics & RFID gate access</p>
              <div class="icon">
                <a routerLink="/organizational-chart"><i class="fas fa-arrow-right"></i></a>
              </div>
            </div>
          </div>
        </div>
        <!-- End Single Item -->
        <!-- Single Item -->
        <div class="col-xl-3 col-lg-6 col-md-6 team-style-four-item">
          <div class="item">
            <div class="thumb">
              <img src="assets/img/team/1.jpg" alt="Institutional Deployments">
              <span>Solutions</span>
            </div>
            <h4><a routerLink="/mentor">Advisory & Institutional Governance</a></h4>
            <div class="social-overlay">
              <p class="text-white px-3 text-center small mb-0">Academic exam integrity, compliance audit & deployment support</p>
              <div class="icon">
                <a routerLink="/mentor"><i class="fas fa-arrow-right"></i></a>
              </div>
            </div>
          </div>
        </div>
        <!-- End Single Item -->
      </div>
    </div>
  </div>
</div>
<!-- End Team  -->
<!-- Start Project
============================================= -->
<div class="project-style-three-area default-padding bg-gray bg-cover"
  style="background-image: url(assets/img/shape/banner-7.jpg);">
  <div class="container">
    <div class="left-heading">
      <div class="row align-center">
        <div class="col-lg-6">
          <h4 class="sub-title">Flagship Deployments</h4>
          <h2 class="title">Proven enterprise solutions delivered for premier institutions</h2>
        </div>
        <div class="col-lg-5 offset-lg-1 text-end">
          <a class="btn-circle circle-border" routerLink="/portfolio"><i class="fas fa-long-arrow-right"></i> All Case Studies</a>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="project-style-three-items">
      <!-- Single Item: JNTUA -->
      <div class="project-style-three-item">
        <div class="row">
          <div class="col-xl-8 col-lg-6">
            <img src="assets/img/projects/3.jpg" alt="JNTUA Online Examination Platform">
          </div>
          <div class="col-xl-4 col-lg-6">
            <div class="project-style-three-info">
              <span>01 / </span>
              <h4><a routerLink="/portfolio">Online Examination & University Assessment Platform</a></h4>
              <p>
                High-concurrency assessment platform engineered for university-wide testing, fault-tolerant session recovery, dynamic MCQ evaluation, and instant performance analytics.
              </p>
              <ul class="pf-tags">
                <li>Cloud Assessment Platform</li>
                <li>University Scale</li>
              </ul>
              <div class="bottom">
                <span>Client / Institution:</span>
                <h5>JNTUA, Anantapur</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- End Single Item -->
      <!-- Single Item: SBES -->
      <div class="project-style-three-item">
        <div class="row">
          <div class="col-xl-8 col-lg-6">
            <img src="assets/img/projects/4.jpg" alt="SBES Multi-Institutional ERP">
          </div>
          <div class="col-xl-4 col-lg-6">
            <div class="project-style-three-info">
              <span>02 / </span>
              <h4><a routerLink="/portfolio">Multi-Institutional Campus ERP & Operations Suite</a></h4>
              <p>
                Comprehensive campus automation encompassing biometric attendance, staff posting & payroll, student admissions, and transport fleet tracking across multi-college campus networks.
              </p>
              <ul class="pf-tags">
                <li>Academic ERP</li>
                <li>Biometrics & IoT</li>
              </ul>
              <div class="bottom">
                <span>Client / Institution:</span>
                <h5>Sri Balaji Educational Society (SBES), Anantapur</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- End Single Item -->
      <!-- Single Item: IoT Smart Gate Security -->
      <div class="project-style-three-item">
        <div class="row">
          <div class="col-xl-8 col-lg-6">
            <img src="assets/img/projects/5.jpg" alt="IoT Biometric Access">
          </div>
          <div class="col-xl-4 col-lg-6">
            <div class="project-style-three-info">
              <span>03 / </span>
              <h4><a routerLink="/portfolio">IoT Biometric Attendance & Smart Security Gateways</a></h4>
              <p>
                Real-time hardware integration connecting biometric turnstiles, barcode student ID access, and vehicle geofencing directly with high-availability cloud infrastructure.
              </p>
              <ul class="pf-tags">
                <li>IoT Gateways</li>
                <li>Hardware Integration</li>
              </ul>
              <div class="bottom">
                <span>Client / Deployment:</span>
                <h5>PVKKIT / Academic Deployments</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- End Single Item -->
    </div>
  </div>
</div>
<!-- End Project -->
<!-- Start Blog
============================================= -->
<div class="home-blog-area default-padding bottom-less">
  <div class="container">
    <div class="row">
      <div class="col-lg-8 offset-lg-2">
        <div class="site-heading text-center">
          <h4 class="sub-title">Insights & Architecture</h4>
          <h2 class="title split-text">Engineering Perspectives <br>& Tech Updates</h2>
          <div class="devider"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="row">
      <!-- Single Item -->
      <div class="col-xl-4 col-md-6 mb-30 wow fadeInUp" data-wow-delay="300ms">
        <div class="blog-style-four">
          <div class="thumb">
            <a routerLink="/portfolio"><img src="assets/img/blog/12.jpg" alt="University Automation"></a>
            <div class="author">
              <div class="name">
                <span>By </span><a routerLink="/portfolio">Novarix Architecture</a>
              </div>
              <div class="avadar">
                <img src="assets/img/teams/6.jpg" alt="Author">
              </div>
            </div>
          </div>
          <div class="info">
            <div class="blog-meta">
              <ul>
                <li>
                  <i class="fas fa-clock"></i> 15 February, 2026
                </li>
              </ul>
            </div>
            <h4>
              <a routerLink="/portfolio">Automating Higher-Education Valuation Workflows with Enterprise Cloud Systems</a>
            </h4>
            <a routerLink="/portfolio" class="btn-animate">
              <span class="circle">
                <span class="icon arrow"></span>
              </span>
              <span class="button-text">Read Case Study</span>
            </a>
          </div>
        </div>
      </div>
      <!-- End Single Item -->
      <!-- Single Item -->
      <div class="col-xl-4 col-md-6 mb-30 wow fadeInUp" data-wow-delay="500ms">
        <div class="blog-style-four">
          <div class="thumb">
            <a routerLink="/portfolio"><img src="assets/img/blog/13.jpg" alt="Telematics"></a>
            <div class="author">
              <div class="name">
                <span>By </span><a routerLink="/portfolio">IoT Solutions Team</a>
              </div>
              <div class="avadar">
                <img src="assets/img/teams/5.jpg" alt="Author">
              </div>
            </div>
          </div>
          <div class="info">
            <div class="blog-meta">
              <ul>
                <li>
                  <i class="fas fa-clock"></i> 18 January, 2026
                </li>
              </ul>
            </div>
            <h4>
              <a routerLink="/portfolio">Real-Time GPS Telematics & Route Analytics: The Resilient Architecture Behind NovaFLEET</a>
            </h4>
            <a routerLink="/portfolio" class="btn-animate">
              <span class="circle">
                <span class="icon arrow"></span>
              </span>
              <span class="button-text">Read Case Study</span>
            </a>
          </div>
        </div>
      </div>
      <!-- End Single Item -->
      <!-- Single Item -->
      <div class="col-xl-4 col-md-6 mb-30 wow fadeInUp" data-wow-delay="700ms">
        <div class="blog-style-four">
          <div class="thumb">
            <a routerLink="/portfolio"><img src="assets/img/blog/14.jpg" alt="Multi-Tenant ERP Security"></a>
            <div class="author">
              <div class="name">
                <span>By </span><a routerLink="/portfolio">Novarix Security</a>
              </div>
              <div class="avadar">
                <img src="assets/img/teams/7.jpg" alt="Author">
              </div>
            </div>
          </div>
          <div class="info">
            <div class="blog-meta">
              <ul>
                <li>
                  <i class="fas fa-clock"></i> 04 December, 2025
                </li>
              </ul>
            </div>
            <h4>
              <a routerLink="/portfolio">Securing Multi-Tenant ERP Systems: Role-Based Access, Isolated DBs & Scale</a>
            </h4>
            <a routerLink="/portfolio" class="btn-animate">
              <span class="circle">
                <span class="icon arrow"></span>
              </span>
              <span class="button-text">Read Case Study</span>
            </a>
          </div>
        </div>
      </div>
      <!-- End Single Item -->
    </div>
  </div>
</div>
<!-- End Blog  -->
